import { DialogContentProps, DialogContent as MuiDialogContent } from "@mui/material";

type Props = DialogContentProps;

export const DialogContent = ({ children, ...props }: Props) => {
  return <MuiDialogContent {...props}>{children}</MuiDialogContent>;
};
